import '@booking-portal/assets/scss/notifications.scss';
import VueNotifications from '@kyvg/vue3-notification';
import type { App } from 'vue';

export function setupNotifications(app: App) {
  app.use(VueNotifications);
}
